import React, { useEffect } from 'react';
import './Pagination.scss';

export default function PaginationSimple(
    {
        totalRecords,
        recordsPerPage,
        currentPage,
        setCurrentPage,
    }
) {

    const nPages = Math.ceil(totalRecords / recordsPerPage);
    const pageNumbers = [...Array(nPages + 1).keys()].slice(1);

    // Au cas où on passe d'une recherche possédant plus de pages que la suivante
    useEffect(() => {
        if (currentPage > nPages) {
            setCurrentPage(1);
        }
    }, [currentPage, nPages, setCurrentPage]);

    const getPages = () => {
        if (nPages <= 5) {
            return pageNumbers;
        }
        if (currentPage <= 3) {
            return [...pageNumbers.slice(0, 4), '...', nPages];
        }
        if (currentPage >= nPages - 2) {
            return [1, '...', ...pageNumbers.slice(nPages - 4)];
        }
        return [1, '...', currentPage - 1, currentPage, currentPage + 1, '...', nPages];
    }

    const pageNumbersDisplay = getPages();

    const nextPage = () => {
        if (currentPage < nPages) {
            setCurrentPage(currentPage + 1);
        }
    }

    const previousPage = () => {
        if (currentPage !== 1) {
            setCurrentPage(currentPage - 1);
        }
    }

    return (
        <>
            {totalRecords > recordsPerPage && (
                <nav aria-label="Page navigation pagination">
                    <ul className="pagination">
                        <li className={`page-item ${currentPage === 1 && 'disabled'}`}>
                            <a
                                className={`page-link ${currentPage === 1 && 'disabled page-link-disabled'}`}
                                onClick={previousPage}
                                href="#infos-gen">
                                Précédent
                            </a>
                        </li>

                        {pageNumbersDisplay.map((pageNumber, index) => (
                            <li key={index}
                                className={`page-item ${currentPage === pageNumber && 'active'}`}>
                                {pageNumber === '...' ? (
                                    <span className="page-link">...</span>
                                ) : (
                                    <a className="page-link" href="#" onClick={() => setCurrentPage(pageNumber)}>
                                        {pageNumber}
                                    </a>
                                )}
                            </li>
                        ))}

                        <li className={`page-item ${currentPage === nPages && 'disabled'}`}>
                            <a
                                className={`page-link ${currentPage === nPages && 'disabled page-link-disabled'}`}
                                href="#infos-gen"
                                onClick={nextPage}>
                                Suivant
                            </a>
                        </li>
                    </ul>
                </nav>
            )}
        </>
    );
}
